// extracted by mini-css-extract-plugin
export default {"hidden":"ToggleBanner_hidden__3WMYS","label":"ToggleBanner_label__1DoI9","banner":"ToggleBanner_banner__-vUxv"};